document.addEventListener('click', function (event) {
  var btn = event.target.closest('.js-amazon-button');
  if (!btn) return;

  if (typeof fbq === 'function') {
    var productId = btn.getAttribute('data-product-id');
    var productTitle = btn.getAttribute('data-product-title');
    var productPrice = btn.getAttribute('data-product-price');
    var currency = btn.getAttribute('data-currency');

    fbq('trackCustom', 'AmazonButtonClick', {
      content_ids: [productId],
      content_name: productTitle,
      content_type: 'product',
      value: productPrice,
      currency: currency
    });
  }
});